const mockData = [
	{
		HotelCode: "CUNMYY",
		HotelName: "Mystique Holbox by Royalton",
		DestinationName: "Isla Holbox",
		RegionName: "Mexico",
	},
	{
		HotelCode: "UVFMRS",
		HotelName: "Mystique St. Lucia by Royalton ",
		DestinationName: "St Lucia",
		RegionName: "Saint Lucia",
	},
	{
		HotelCode: "MBJHAR",
		HotelName: "Hideaway at Royalton Negril",
		DestinationName: "Negril",
		RegionName: "Jamaica",
	},
	{
		HotelCode: "CUN7HR",
		HotelName: "Hideaway at Royalton Riviera Cancun",
		DestinationName: "Riviera Maya",
		RegionName: "Mexico",
	},
	{
		HotelCode: "CUN7RC",
		HotelName: "Royalton Riviera Cancun Resort and Spa",
		DestinationName: "Riviera Maya",
		RegionName: "Mexico",
	},
	{
		HotelCode: "PUJ7CH",
		HotelName: "Royalton CHIC Punta Cana Resort & Spa",
		DestinationName: "Punta Cana",
		RegionName: "Dominican Republic",
	},
	{
		HotelCode: "CUNRCS",
		HotelName: "Royalton CHIC Suites Cancun Resort and Spa",
		DestinationName: "Cancun",
		RegionName: "Mexico",
	},
	{
		HotelCode: "PUJROY",
		HotelName: "Royalton Bavaro Resort and Spa",
		DestinationName: "Punta Cana",
		RegionName: "Dominican Republic",
	},
	{
		HotelCode: "PUJROB",
		HotelName: "Royalton Splash Punta Cana Resort and Spa",
		DestinationName: "Punta Cana",
		RegionName: "Dominican Republic",
	},
	{
		HotelCode: "PUJHAR",
		HotelName: "Hideaway at Royalton Punta Cana",
		DestinationName: "Punta Cana",
		RegionName: "Dominican Republic",
	},
	{
		HotelCode: "PUJ7RP",
		HotelName: "Royalton Punta Cana Resort And Casino",
		DestinationName: "Punta Cana",
		RegionName: "Dominican Republic",
	},
	{
		HotelCode: "MBJRNR",
		HotelName: "Royalton Negril Resort and Spa",
		DestinationName: "Negril",
		RegionName: "Jamaica",
	},
	{
		HotelCode: "MBJRBW",
		HotelName: "Royalton Blue Waters",
		DestinationName: "Montego Bay",
		RegionName: "Jamaica",
	},
	{
		HotelCode: "VRAROI",
		HotelName: "Royalton Hicacos Resort and Spa",
		DestinationName: "Varadero",
		RegionName: "Cuba",
	},
	{
		HotelCode: "MBJ7RW",
		HotelName: "Royalton White Sands Montego Bay",
		DestinationName: "Montego Bay",
		RegionName: "Jamaica",
	},
	{
		HotelCode: "UVFRSL",
		HotelName: "Royalton Saint Lucia Resort and Spa",
		DestinationName: "St Lucia",
		RegionName: "Saint Lucia",
	},
	{
		HotelCode: "UVFHAR",
		HotelName: "Hideaway at Royalton Saint Lucia",
		DestinationName: "St Lucia",
		RegionName: "Saint Lucia",
	},
	{
		HotelCode: "GNDRGR",
		HotelName: "Royalton Grenada Resort and Spa ",
		DestinationName: "Grenada",
		RegionName: "Grenada",
	},
	{
		HotelCode: "SNURCS",
		HotelName: "Royalton Cayo Santa Maria",
		DestinationName: "Cayo Santa Maria",
		RegionName: "Cuba",
	},
	{
		HotelCode: "ANURAR",
		HotelName: "Royalton Antigua Resort and Spa",
		DestinationName: "Antigua",
		RegionName: "Antigua and Barbuda",
	},
];

export default mockData;
